export const AdminsActors = {
    TOGGLE_ADMINS:'TOGGLE_ADMINS',
    ADMINS_LIST:'ADMINS_LIST',
    TOGGLE_ACTIVE_ADMINS:'TOGGLE_ACTIVE_ADMINS',
    ACTIVE_ADMINS_LIST:'ACTIVE_ADMINS_LIST',
    TOGGLE_DEACTIVATE_ADMINS:'TOGGLE_DEACTIVATE_ADMINS',
    DEACTIVATE_ADMINS_LIST:'DEACTIVATE_ADMINS_LIST',
    TOGGLE_DELETED_ADMINS:'TOGGLE_DELETED_ADMINS',
    DELETED_ADMINS_LIST:'DELETED_ADMINS_LIST',
}